(function () {
  'use strict';

  var linkConfig = document.currentScript;
  var newTabLabel = linkConfig && linkConfig.getAttribute('data-new-tab-label') || '';
  var rootUrl = linkConfig && linkConfig.getAttribute('data-root-url') || '/';
  var APPLICATION_PAGES = {
    'WB': 'application-western-blot',
    'IHC': 'application-ihc', 'IHC-P': 'application-ihc', 'IHC-F': 'application-ihc',
    'IF': 'application-if', 'IF(IHC-P)': 'application-if', 'IF(IHC-F)': 'application-if',
    'IF(ICC)': 'application-if', 'ICC': 'application-if', 'ICC/IF': 'application-if', 'IF/ICC': 'application-if',
    'FCM': 'application-flow-cytometry', 'FLOW-CYT': 'application-flow-cytometry',
    'FLOWCYTOMETRY': 'application-flow-cytometry', 'FACS': 'application-flow-cytometry',
    'ELISA': 'application-elisa-kits', 'IP': 'application-immunoprecipitation'
  };

  function linkApplicationPill(pill, label) {
    if (!document.body.classList.contains('template-product')) return;
    if (!pill.matches('.product-details ul.tags.applications li, #product-attributes .dilution-tag span, #product-attributes ul.tags.applications li, #product-attributes .bioss-pair-overview-application')) return;
    var page = APPLICATION_PAGES[label];
    if (!page || pill.querySelector('a')) return;
    var link = document.createElement('a');
    link.className = 'bioss-product-application-link';
    link.href = rootUrl.replace(/\/$/, '') + '/pages/' + page;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = pill.textContent;
    if (newTabLabel) link.setAttribute('aria-label', pill.textContent.trim() + ' ' + newTabLabel);
    pill.textContent = '';
    pill.appendChild(link);
    pill.classList.add('bioss-linked-application');
  }

  var COLOR_MAP = {
    'WB': '#98c33c',
    'IHC-P': '#ebc138',
    'IHC-F': '#ee644a',
    'IF(IHC-P)': '#2cd4bf',
    'IF(IHC-F)': '#ff62a4',
    'IF(ICC)': '#004aad',
    'ICC': '#004aad',
    'ELISA': '#73caee',
    'LFA': '#a3cd3f',
    'CLIA': '#2b1263',
    'FCM': '#ff3131',
    'IP': '#271264'
  };

  function normalizeApplicationLabel(text) {
    return (text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, '')
      .replace(/[（]/g, '(')
      .replace(/[）]/g, ')')
      .toUpperCase();
  }

  function colorApplicationPills(root) {
    root = root || document;
    var selector = [
      '.product-details ul.tags li',
      '#product-attributes .dilution-tag span',
      '#product-attributes ul.tags li',
      '.bioss-ivd-card__top strong',
      '.bioss-assay-dilution-table__application',
      '.bioss-pair-overview-application',
      '.bioss-card-application-pill'
    ].join(',');

    var pills = root.querySelectorAll(selector);
    for (var i = 0; i < pills.length; i += 1) {
      var pill = pills[i];
      var label = normalizeApplicationLabel(pill.textContent);
      if (label === 'ICA') {
        pill.textContent = 'LFA';
        pill.setAttribute('data-bioss-source-application', 'ICA');
        label = 'LFA';
      }

      var color = COLOR_MAP[label];
      linkApplicationPill(pill, label);
      if (!color) {
        if (pill.classList.contains('bioss-card-application-pill')) pill.style.setProperty('color', '#ffffff', 'important');
        continue;
      }
      pill.style.backgroundColor = color;
      var foreground = '#ffffff';
      pill.style.setProperty('color', foreground, 'important');
      pill.setAttribute('data-bioss-app-pill-color', color);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { colorApplicationPills(document); });
  } else {
    colorApplicationPills(document);
  }

  window.addEventListener('load', function () { colorApplicationPills(document); });

  if (window.MutationObserver) {
    var scanTimer = null;
    var observer = new MutationObserver(function () {
      if (scanTimer) window.clearTimeout(scanTimer);
      scanTimer = window.setTimeout(function () {
        scanTimer = null;
        colorApplicationPills(document);
      }, 150);
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
